import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** code generate by generateapi don't edit */
import { getClient } from './internal'; // @error:
// ossreport.ErrInvalidRequestData invalid request data
// svr options: (ext.CmdID) = 1
// svr options: (ext.Url) = /weblogic/wechat/get_wxa_code_unlimit

/** @type {(r: ext.RawReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function GetWxaCodeUnlimit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/GetWxaCodeUnlimit",
    "auth": "1"
  }), o));
}
; // @error:
// wechat.ErrWechat 系统错误
// wechat.ErrUnknownAuthType 未知的authType
// ErrMissedAppId
// ErrMissedPath
// svr options: (ext.CmdID) = 5
// svr options: (ext.Url) = /weblogic/wechat/create_wxa_qrcode

/** @type {(r: ext.RawReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function CreateWxaQrcode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/CreateWxaQrcode",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 6

/** @type {(r: wechat.EncodeWxaSceneReq, b: any) => Promise<wechat.EncodeWxaSceneRes>} TypeScript syntax */

export function EncodeWxaScene(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/EncodeWxaScene",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 7

/** @type {(r: wechat.DecodeWxaSceneReq, b: any) => Promise<wechat.DecodeWxaSceneRes>} TypeScript syntax */

export function DecodeWxaScene(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/DecodeWxaScene",
    "auth": "1"
  }), o));
}
; // @error:
// ErrInvalidLogin
// ErrMissedAppIdHeader
// svr options: (ext.CmdID) = 8

/** @type {(r: weblogic.ReportWxaFormIdReq, b: any) => Promise<weblogic.ReportWxaFormIdRsp>} TypeScript syntax */

export function ReportWxaFormId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/ReportWxaFormId",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 2
// svr options: (ext.Url) = /weblogic/wechat/callback/:app_id

/** @type {(r: ext.RawReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function GetWxaCallback(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/GetWxaCallback",
    "auth": "1"
  }), o));
}
; // svr options: (ext.CmdID) = 3
// svr options: (ext.Url) = /weblogic/union/get_ip

/** @type {(r: ext.RawReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function GetIp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/GetIp",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 待废弃
// @error:
// storage.ErrConfigMiss 配置缺失
// storage.ErrUploadFail
// svr options: (ext.CmdID) = 4
// svr options: (ext.Url) = /weblogic/storage/upload

/** @type {(r: ext.RawReq, b: any) => Promise<storage.UploadRes>} TypeScript syntax */

export function Upload(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/Upload",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// storage.ErrConfigMiss 配置缺失
// svr options: (ext.CmdID) = 9

/** @type {(r: weblogic.PreUploadReq, b: any) => Promise<storage.PreUploadV2Rsp>} TypeScript syntax */

export function PreUpload(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/PreUpload",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// storage.ErrInvalidResourceState
// storage.ErrConfigMiss 配置缺失
// svr options: (ext.CmdID) = 10

/** @type {(r: weblogic.UploadCallBackReq, b: any) => Promise<storage.UploadCallBackV2Rsp>} TypeScript syntax */

export function UploadCallBack(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/UploadCallBack",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// wechat.ErrEncryptFailure 加密失败
// wechat.ErrDecryptFailure 解密失败
// svr options: (ext.CmdID) = 11
// svr options: (ext.Url) = /weblogic/wechat/official/callback/:appid

/** @type {(r: ext.RawReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function ReceiveOfficialAccountEvent(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/ReceiveOfficialAccountEvent",
    "auth": "1"
  }), o));
}
; // @error:
// wechat.ErrUnknownAuthType 未知的authType
// wechat.ErrNotOfficialApp 非公众号
// wechat.ErrWechat 系统错误
// svr options: (ext.CmdID) = 12

/** @type {(r: weblogic.JsConfigReq, b: any) => Promise<weblogic.JsConfigRsp>} TypeScript syntax */

export function JsConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/JsConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// svr options: (ext.CmdID) = 13

/** @type {(r: weblogic.GetLarkScanLoginUrlReq, b: any) => Promise<weblogic.GetLarkScanLoginUrlRsp>} TypeScript syntax */

export function GetLarkScanLoginUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/GetLarkScanLoginUrl",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// corp.ErrCorpExisted
// lark.ErrInvalidCode
// lark.ErrErrLarkApiSysErr
// lark.ErrUserNotFound
// corp.ErrCorpNotFound
// lark.ErrMissTenantKey
// lark.ErrErrLarkApiNotPermit
// lark.ErrLarkApiError
// qoll.ErrInvalidScanLoginState
// svr options: (ext.CmdID) = 14

/** @type {(r: weblogic.LarkScanLoginReq, b: any) => Promise<weblogic.LarkScanLoginRsp>} TypeScript syntax */

export function LarkScanLogin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/LarkScanLogin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// wework.ErrWwBizErr
// svr options: (ext.CmdID) = 15

/** @type {(r: weblogic.GetWeWorkJsConfigReq, b: any) => Promise<weblogic.GetWeWorkJsConfigRsp>} TypeScript syntax */

export function GetWeWorkJsConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/weblogic/GetWeWorkJsConfig",
    "auth": "1"
  }), o));
}
;
var WeblogicServices = {
  GetWxaCodeUnlimit: GetWxaCodeUnlimit,
  CreateWxaQrcode: CreateWxaQrcode,
  EncodeWxaScene: EncodeWxaScene,
  DecodeWxaScene: DecodeWxaScene,
  ReportWxaFormId: ReportWxaFormId,
  GetWxaCallback: GetWxaCallback,
  GetIp: GetIp,
  Upload: Upload,
  PreUpload: PreUpload,
  UploadCallBack: UploadCallBack,
  ReceiveOfficialAccountEvent: ReceiveOfficialAccountEvent,
  JsConfig: JsConfig,
  GetLarkScanLoginUrl: GetLarkScanLoginUrl,
  LarkScanLogin: LarkScanLogin,
  GetWeWorkJsConfig: GetWeWorkJsConfig
};
export default WeblogicServices;